import { Table as AntTable, TableProps as AntTableProps } from "antd";
import { SorterResult, TablePaginationConfig } from "antd/lib/table/interface";

export interface ColumnType {
  field?: string;
  type?: string;
  title?: any;
}

export interface TableProps
  extends Omit<AntTableProps<Record<string, any>>, "pagination"> {
  dataSource: any[];
  keyField?: string;
  isLoading?: boolean;
  isFetching?: boolean;
  pagination?: false | TablePaginationConfig;
  setPagination?: any;
  setSorter?: any;
  total?: number;
  columns?: ColumnType[];
  columnCountConfig?: boolean;
  showAllColumns?: boolean;
  rowClassName?: any;
}

const Table: React.FC<TableProps> = ({
  dataSource = [],
  keyField,
  isLoading,
  isFetching,
  pagination = false,
  setSorter,
  columns: columnConfig,
  rowClassName,
  ...rest
}) => {
  const columns = columnConfig;

  let items = dataSource;
  if (keyField) {
    items = dataSource.map((i) => ({ ...i, key: i[keyField] }));
  }
  return (
    <AntTable
      columns={columns}
      dataSource={items}
      loading={isLoading || isFetching}
      {...(rowClassName ? { rowClassName } : null)}
      pagination={
        pagination === false
          ? { hideOnSinglePage: true, pageSize: items.length }
          : pagination
      }
      onChange={(/*tablePagination, filter,*/ sorter) => {
        const sort = sorter as any;

        setSorter?.(
          (sort?.column
            ? { ...sorter, field: sort?.column?.sortField || sort.field }
            : {}) as SorterResult<any>
        );
      }}
      showSorterTooltip={false}
      scroll={{ x: "100%" }}
      {...rest}
    />
  );
};

export default Table;
